import * as React from "react";
const ToggleOff = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 10 2", fill: "currentColor", width: size || "10", height: size || "2", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0H10V2H0z" }));
ToggleOff.displayName = "ToggleOff";
var ToggleOff_default = ToggleOff;
export {
  ToggleOff_default as default
};
